// API Gateway URL (환경변수에서 가져옴)
const API_GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL || 'http://localhost:30080';

const urls = {
    // WIZ-SSO API - 인증
    "ssoLogin": "/wizsso/api/v2/auth/login",
    "ssoSocialLogin": "/wizsso/api/v2/auth/social",
    "ssoSignup": "/wizsso/api/v2/auth/signup",
    "ssoRefresh": "/wizsso/api/v2/auth/refresh",
    "ssoRevoke": "/wizsso/api/v2/auth/revoke",
    "ssoUser": "/wizsso/api/v2/auth/user",

    // MOI API - 모임 관리
    "meetings": "/moi/api/v1/meetings",
    "meetingDetail": "/moi/api/v1/meetings",
    "meetingMembers": "/moi/api/v1/meetings",
    "meetingInvite": "/moi/api/v1/meetings",
    "meetingJoin": "/moi/api/v1/meetings",
    "meetingLeave": "/moi/api/v1/meetings",

    // MOI API - 일정 관리
    "schedules": "/moi/api/v1/meetings",
    "scheduleVote": "/moi/api/v1/schedules",
    "scheduleConfirm": "/moi/api/v1/schedules",
    "scheduleAiRecommend": "/moi/api/v1/meetings",
    "scheduleProposals": "/moi/api/v1/schedule-proposals",
    "scheduleStatistics": "/moi/api/v1/meetings",
    "scheduleProposalVote": "/moi/api/v1/schedule-proposals",
    "scheduleConfirmFromProposal": "/moi/api/v1/schedules",

    // MOI API - 정산 관리
    "payments": "/moi/api/v1/meetings",
    "paymentDetail": "/moi/api/v1/payments",
    "paymentRequest": "/moi/api/v1/payments",
    "paymentComplete": "/moi/api/v1/payments",
    "receiptOcr": "/moi/api/v1/meetings",

    // MOI API - 채팅
    "chatMessages": "/moi/api/v1/chats/meetings",
    "chatRead": "/moi/api/v1/chats",

    // MOI API - 서브 장소
    "subPlaces": "/moi/api/v1/meetings",

    // WIZ-COMMON API - 공지사항
    "notices": "/wizcommon/api/v2/notice",
    "noticeDetail": "/wizcommon/api/v2/notice",

    // WIZ-COMMON API - FAQ
    "faqs": "/wizcommon/api/v2/faq",

    // WIZ-COMMON API - QNA/의견보내기
    "qnas": "/wizcommon/api/v2/qna",
    "qnaDetail": "/wizcommon/api/v2/qna",
    "qnaSend": "/wizcommon/api/v2/qna/send",

    // WIZ-COMMON API - 약관
    "terms": "/wizcommon/api/v2/terms",
    "termsDetail": "/wizcommon/api/v2/terms",
    "termsByType": "/wizcommon/api/v2/terms/type",
}

export const getApiUrl = (name: keyof typeof urls) => {
    return API_GATEWAY_URL + urls[name];
}

// 환경 정보 유틸리티
export const getEnv = () => process.env.REACT_APP_ENV || 'local';
export const isDebug = () => process.env.REACT_APP_DEBUG === 'true';
export const getGatewayUrl = () => API_GATEWAY_URL;
export const getSsoUrl = () => process.env.REACT_APP_SSO_URL || 'http://localhost:3001';
export const getServiceId = () => process.env.REACT_APP_SERVICE_ID || 'MOI';
export const getClientId = () => process.env.REACT_APP_CLIENT_ID || 'MOI_CLIENT';
